function addStyle(url) {
    let doc = document;
    let link = doc.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', url);
    return addHtmlElement(link);
}

function addScript(url) {
    let doc = document;
    let script = doc.createElement('script');
    script.setAttribute('src', url);
    return addHtmlElement(script);
}

function addHtmlElement(ele) {
    return new Promise(function (resolve, reject) {
        if (ele) {
            let heads = document.getElementsByTagName('head');
            if (heads.length) {
                heads[0].appendChild(ele);
                ele.onload = function () {
                    setTimeout(function () {
                        resolve('loaded');
                    }, 10);
                }
                ele.onerror = function (err) {
                    reject(err);
                }
            }
        } else {
            reject('Parameters ele is illegal');
        }
    });
};

let loaded = [];

export const addSources = function (sources) {
    return new Promise(function (resolve, reject) {
        if (sources && sources.length) {
            let promises = sources.map((sourceSrc) => {
                if (loaded.includes(sourceSrc)) {
                    return Promise.resolve('loaded already');
                }
                if (/\.css$/.test(sourceSrc)) {
                    return addStyle(sourceSrc);
                } else if (/\.js$/.test(sourceSrc)) {
                    return addScript(sourceSrc);
                } else {
                    return Promise.reject('not supported extension');
                }
            });
            Promise.all(promises).then(() => {
                loaded = loaded.concat(sources);
                resolve(sources.join('\n') + ' loaded!');
            }).catch(err => {
                Owl.addError('lazyLoadError', {
                    level: 'info',
                    combo: false,
                    tags: err
                })
                reject(err);
                window.alert('加载资源失败，请刷新网页');
            });
        }
        else {
            reject('Paramters sources is illegal');
        }
    });
};


// WEBPACK FOOTER //
// ./src/utils/lazyLoad.js